export default __webpack_public_path__ + "static/media/vf-attachment-updated.dda81bbd.svg";